import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import GlobalAlerts from './GlobalAlerts';

class LayoutBase extends Component {
  static displayName = 'Layout';

  render() {
    const path = window.location.pathname || '';
    const hideHeader = false;
    const isFullWidth = true; // use full width globally
    return (
      <div>
        {!hideHeader && <NavMenu />}
        <GlobalAlerts />
        <Container fluid={isFullWidth} tag="main" style={{padding: 0}}>
          {this.props.children}
        </Container>
      </div>
    );
  }
}

export const Layout = LayoutBase;
